import React from 'react'
import { useTranslation } from '@mc/i18n'
import { useExperiment } from '../../hooks/useExperiment'
import { PLAN_Z_FREE_GIFT_I18N_NAMESPACE } from '../../i18n'

export const ExplainerModalLegend = () => {
  const { t } = useTranslation(PLAN_Z_FREE_GIFT_I18N_NAMESPACE)

  const { isVariant: isPlanZFreeGift } = useExperiment({ isGift: false })

  if (!isPlanZFreeGift) return null

  return <p className='mc-mt-8'>{t('freeGift.explainer.legend')}</p>
}
